import { REST_API_URL, REST_API_VERSION } from '@/config/constants';

export const getRestApiBaseUrlWithVersion = () => {
  if (REST_API_URL.endsWith('/')) {
    return REST_API_URL + REST_API_VERSION;
  }
  return `${REST_API_URL}/${REST_API_VERSION}`;
};
